import { FcGeneratorOptions, FcShape } from '@dtx-company/flowcode-generator-types/src'

export type Options =
  | 'containerShape'
  | 'containerEmptySpaceSize'
  | 'gridModuleRandomSizes'
  | 'dataGridPercentageSize'
  | 'containerOuterPatternRandomSizes'
  | 'containerImageOverlayPrivacy'
  | 'containerImageUrl'
  | 'containerImageUrlFillSvg'

export const getSquareShapeOptions = (id: string): Pick<FcGeneratorOptions, Options> => {
  let randomSizes = '99'
  let containerImageUrl = 'https://cdn.flowcode.com/prodassets/container_shaggy.svg'

  switch (id.toLowerCase()) {
    case 'diamond':
      randomSizes = '105'
      containerImageUrl = 'https://cdn.flowcode.com/prodassets/container_diamond.svg'
      break
    case 'heart':
      randomSizes = '95'
      containerImageUrl = 'https://cdn.flowcode.com/prodassets/container_heart.svg'
      break
    case 'star':
      randomSizes = '115'
      containerImageUrl = 'https://cdn.flowcode.com/prodassets/container_star.svg'
      break
    case 'triangle':
      randomSizes = '110'
      containerImageUrl = 'https://cdn.flowcode.com/prodassets/container_triangle.svg'
      break
    case 'square':
      randomSizes = '76'
      containerImageUrl = 'https://cdn.flowcode.com/prodassets/container_square.svg'
      break
    case 'circle':
      randomSizes = '85'
      containerImageUrl = 'https://cdn.flowcode.com/prodassets/container_circle.svg'
      break
  }

  return {
    containerShape: FcShape.SQUARE,
    containerEmptySpaceSize: 12,
    gridModuleRandomSizes: randomSizes,
    dataGridPercentageSize: 90,
    containerOuterPatternRandomSizes: randomSizes,
    containerImageOverlayPrivacy: false,
    containerImageUrl: containerImageUrl,
    containerImageUrlFillSvg: true
  }
}
